import { render } from "./Lift.vue?vue&type=template&id=593ff205&scoped=true&bindings={\"zoomed\":\"data\",\"liftMusic\":\"data\",\"doorSound\":\"data\",\"blurred\":\"data\",\"muted\":\"data\",\"highlighted\":\"data\",\"img1\":\"data\",\"img2\":\"data\",\"img3\":\"data\",\"zoomPanel\":\"options\",\"goToFloor\":\"options\",\"goBack\":\"options\",\"highlight\":\"options\",\"switchSound\":\"options\"}"
import script from "./Lift.vue?vue&type=script&lang=js"
export * from "./Lift.vue?vue&type=script&lang=js"

import "./Lift.vue?vue&type=style&index=0&id=593ff205&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-593ff205"

export default script